import { render, staticRenderFns } from "./PcStatusDetail.vue?vue&type=template&id=5f83c14b"
import script from "./PcStatusDetail.vue?vue&type=script&lang=js"
export * from "./PcStatusDetail.vue?vue&type=script&lang=js"
import style0 from "./PcStatusDetail.vue?vue&type=style&index=0&id=5f83c14b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports